module.exports = __webpack_public_path__ + "static/media/ProductPhotography.162bbfe1.png";